import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux';
import swal from 'sweetalert';
import './application-form.css'
import { BounceLoader } from 'react-spinners';
import { loaderEnd, loaderStart } from '../../components/loader';
import { getApplication, updateApplication } from './api';
import { dateStandard } from "../../shared/dateFn";
import { departments } from "./constants";


import Wizard from '../Wizard';
import RejectionNotice from '../../components/rejectionNotice'

// The API returns NULL for every column the candidate has not filled yet.
// Passing value={null} to an input makes React treat it as UNCONTROLLED, so it
// stops tracking what is typed and logs "changing a controlled input to be
// uncontrolled". Coercing null/undefined to "" keeps every field controlled for
// the whole lifetime of the form, which is what React requires.
const noNulls = (obj) =>
    Object.fromEntries(
        Object.entries(obj || {}).map(([k, v]) => [k, v === null || v === undefined ? "" : v])
    )

const ApplicationForm = (props) => {
    const navigate = useNavigate();
    const override = {
        display: "block",
        margin: "0 auto",
        borderColor: "red",
        height: '80vh'
    };
    let [loading, setLoading] = useState(false);
    let [color, setColor] = useState("blue");

    const [disabled, setDisabled] = useState(false)
    const [status, setStatus] = useState(false)

    const [state, setState] = useState({
        name: "",
        email: "",
        gender: "",

        designation: "",
        id_proof: "",
        aadhar: "",

        service: "",
        service_cadre:"",
        // Bound to an input but previously absent from this initial shape, so
        // it started as `undefined` — an uncontrolled input that became
        // controlled the moment the API responded, which is exactly the
        // transition React warns about and where typed input gets lost.
        mobile: "",
        category: "",
        department: "",
        hrms_id: "",
        office_address: "",
        other_details: "",
        gpr_id: "",

        photo: "",
        signature: "",
        proof: "",
        formUpdated: 1
    })

    useEffect(() => {
        getData()
    }, [])

    let getData = async (afterPrint) => {
        loaderStart()
        let res = await getApplication();
        console.log(res);
        if (res.code == 1) {
            let data = {
                ...res.data,
                photoImg: res.data.passport,
                signatureImg: res.data.signature,
                proofImg: res.data.proof,
            }
            delete data.passport;
            delete data.signature;
            delete data.proof;
            if (afterPrint) {
                setState((prev) => ({ ...prev, ...noNulls(data), formUpdated: state.formUpdated + 1 }))
                setTimeout(() => {
                    Print()
                    window.location.reload()
                }, 1000)
            }
            else {
                setState((prev) => ({ ...prev, ...noNulls(data) }))
            }

            setDisabled((data.is_approved === 0 && res.data.document) || data.is_approved === 1 ? true : false)
            if (res.data.passport) {
                setStatus(true)
            }

            if (afterPrint) {

            }
            // setDisabled(true)
        }
        loaderEnd()
    }

    useEffect(() => {
        // Print()
        // window.location.reload()
    }, [state.formUpdated])


    const handleChange = (e, type) => {
        // console.log(e.target.name);
        let _state = { ...state }
        if (e.target.type === "file") {
            _state[e.target.name] = e.target.files[0]
        }
        else {
            _state[e.target.name] = e.target.value
        }
        setState(_state)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        loaderStart()
        console.log(state);
        let formData = new FormData();
        for (let [key, val] of Object.entries(state)) {

            if (val)
                formData.append(key, val);
        }
        if (!state.photo) {
            formData.append("photo", state.photoImg);
        }
        if (!state.signature) {
            formData.append("signature", state.signatureImg);
        }
        if (!state.proof) {
            formData.append("proof", state.proofImg);
        }
        let res = await updateApplication(formData)
        console.log(res);
        if (res.code == 1) {
            swal("Application Form Saved", "अग्रसारण करने में आपको फिलहाल 1 - 2  दिन लग सकता है।  अंतः अभी आप SignOut  कर ले और जब आपके नियंत्री पदाधिकारी से अग्रसारित करा ले तब पुनः विभागीय परीक्षा Portal पर Login कर उक्त अग्रसारित आवेदन पत्र को अपलोड करें |  ", "success")
                .then((value) => {
                    getData(true)
                });
        }
        else {
            swal(res.msg, "", "error")
        }
        loaderEnd()

    }

    const Print = () => {
        //console.log('print');  
        let printContents = document.getElementById('application-format').innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    const [inputData, setInputData] = useState({
        fullname: ''
    })
    function changeHandle(e) {
        setInputData({ ...inputData, [e.target.name]: e.target.value })
    }
    let { fullname } = inputData

    const showalert = () => {
        swal("Application Form Saved", "अग्रसारण करने में आपको फिलहाल 1 - 2  दिन लग सकता है।  अंतः अभी आप SignOut  कर ले और जब आपके नियंत्री पदाधिकारी से अग्रसारित करा ले तब पुनः विभागीय परीक्षा Portal पर Login कर उक्त अग्रसारित आवेदन पत्र को अपलोड करें |  ", "success")
            .then((value) => {
                Print()
                window.location.reload()
            });
    }

    console.log(props.auth.auth);

    const updateDOB = (dob) => {
        if (dob) {
            return dob.split("T")[0]
        }
    }

    return (
        <>
            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="card  application-box">
                    <Wizard
                        application={status}
                        title="Computer Competency Test Examination Form"
                        redirect='/application'
                    />


                    {/* Outside #applications, which is what gets printed. */}
                    <RejectionNotice />
                    <p align="right"><i style={{ color: 'red', fontSize: '16px' }}>Fields marked with (*) are mandatory</i></p>
                    <div id="applications" className='application-body application-form-box'>

                        <div className='card application-form'>
                            <h2 className="ui_section_title">Personal Details / व्यक्तिगत विवरण</h2>
                            <div className="row  mt-3">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Registered Mobile Number/पंजीकृत मोबाइल नंबर</label>
                                <div className="col-sm-4">
                                    <input
                                        disabled={true}
                                        type="number" value={state.mobile} className="form-control" id="inputEmail3" />
                                </div>
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Date of Birth/जन्म तिथि:</label>
                                <div className="col-sm-4">
                                    <input disabled={true} value={updateDOB(props.auth.auth?.data?.dob)} type="date" className="form-control" id="inputEmail3" />
                                </div>
                            </div>

                            <div className="row">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">
                                    <i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>
                                    Full Name / पूरा नाम :
                                </label>
                                <div className="col-sm-4">
                                    <input
                                        type="text"
                                        name='name'
                                        value={state.name}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        disabled={true}
                                        className="form-control"
                                        id="inputEmail3"
                                    />
                                </div>

                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">
                                    <i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>
                                    Aadhar No/आधार संख्या
                                </label>
                                <div className="col-sm-4">
                                    <input
                                        type="number"
                                        className="form-control"
                                        name='aadhar'
                                        value={props.auth.auth?.data?.aadhar}
                                        disabled={true}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        id="inputEmail3" />
                                </div>
                            </div>

                            <div className="row mb-3 mt-3">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Email / ईमेल:</label>
                                <div className="col-sm-4">
                                    <input
                                        type="email"
                                        name='email'
                                        value={state.email}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        disabled
                                        className="form-control" id="inputEmail3" />
                                </div>
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Id Proof / पहचान प्रमाण:</label>
                                <div className="col-sm-4">
                                    <select
                                        name='id_proof'
                                        value={state.id_proof}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        disabled={disabled}
                                        className="form-select" id="autoSizingSelect">
                                        <option value=''> Select Id Proof / पहचान प्रमाण</option>
                                        <option value="PAN No.">PAN No.</option>
                                        <option value="Aadhar No.">Aadhar No.</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3 mt-3 ">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Gender / लिंग</label>
                                <div className="col-sm-4 ">
                                    <div className='radio-group '>
                                        <input
                                            name='gender'
                                            value={"M"}
                                            checked={state.gender === "M" ? true : false}
                                            onChange={(e) => handleChange(e)}
                                            required
                                            disabled={disabled}
                                            type="radio" className="form-control form-check-input" id="inputEmail3" />
                                        <label className="form-check-label" htmlFor="gridRadios1">
                                            Male
                                        </label>
                                        <input
                                            name='gender'
                                            value={"F"}
                                            checked={state.gender === "F" ? true : false}
                                            onChange={(e) => handleChange(e)}
                                            required
                                            disabled={disabled}
                                            type="radio" className="form-control form-check-input" id="inputEmail3" />
                                        <label className="form-check-label" htmlFor="gridRadios1">
                                            Female
                                        </label><input
                                            name='gender'
                                            value={"T"}
                                            checked={state.gender === "T" ? true : false}
                                            onChange={(e) => handleChange(e)}
                                            required
                                            disabled={disabled}
                                            type="radio" className="form-control form-check-input" id="inputEmail3" />
                                        <label className="form-check-label" htmlFor="gridRadios1">
                                            Transgender
                                        </label>
                                    </div>
                                </div>
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Category / वर्ग:</label>
                                <div className="col-sm-4">
                                    <select
                                        name='category'
                                        value={state.category}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        disabled={disabled}
                                        className="form-select" id="autoSizingSelect"
                                    >
                                        <option value=''>Select Category / वर्ग का चयन करें</option>
                                        <option value="Others including general">Others including general</option>
                                        <option value="SC/ST">SC/ST</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Designation / पदनाम:</label>
                                <div className="col-sm-4">
                                    <input type="text" className="form-control" id="autoSizingSelect"
                                        name='designation'
                                        value={state.designation}
                                        disabled={disabled}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    />
                                </div>
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"> <i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Department / विभाग:</label>
                                <div className="col-sm-4">
                                    <select className="form-select" id="autoSizingSelect"
                                        name='department'
                                        value={state.department}
                                        onChange={(e) => handleChange(e)}
                                        disabled={disabled}
                                        required
                                    >
                                        <option value=''>Select Department</option>
                                        {
                                            departments.map((d, i) => (
                                                <option value={d.key} key={i}>{d.key}</option>
                                            ))
                                        }

                                        <option value="PRAN">PRAN</option>
                                    </select>
                                    {/* <input type="text" className="form-control" id="autoSizingSelect"
                                        name='department'
                                        value={state.department}
                                        disabled={disabled}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    /> */}

                                </div>
                            </div>

                            <div className="row mb-3 mt-3">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Service / सेवा:</label>
                                <div className="col-sm-4">
                                    <select className="form-select" id="autoSizingSelect"
                                        name='service'
                                        value={state.service}
                                        disabled={disabled}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    >
                                        <option value=''>Select Service</option>
                                        <option value="Gazatted">Gazetted</option>
                                        <option value="Non-Gazatted">Non-Gazetted</option>
                                    </select>
                                </div>

                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">HRMS ID</label>
                                <div className="col-sm-4">
                                    <input type="text" className="form-control" id="inputEmail3"
                                        name='hrms_id'
                                        value={state.hrms_id}
                                        disabled={disabled}
                                        onChange={(e) => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3 mt-3">
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Other's Details</label>
                                <div className="col-sm-4">
                                    <select className="form-select" id="autoSizingSelect"
                                        name='other_details'
                                        value={state.other_details}
                                        onChange={(e) => handleChange(e)}
                                        disabled={disabled}
                                        required
                                    >
                                        <option value=''>Select Other Service</option>
                                        <option value="GPF">GPF</option>
                                        <option value="PRAN">PRAN</option>
                                    </select>
                                </div>
                                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> GPF/PRAN ID</label>
                                <div className="col-sm-4">
                                    <input type="text" className="form-control" id="inputEmail3"
                                        name='gpr_id'
                                        value={state.gpr_id}
                                        disabled={disabled}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mb-3 mt-3">
                                <label className='col-sm-2 col-form-label'><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i> Service Cadre / सेवा संवर्ग</label>
                                <div className='col-sm-4'>
                                    <select disabled={disabled} required name='service_cadre' className="form-select" id="autoSizingSelect" onChange={(e) => handleChange(e)} value={state.service_cadre} >
                                        <option value="">Select Service Cadre </option>
                                        <option value="Indian Administrative Service">Indian Administrative Service</option>
                                        <option value="Indian Police Service">Indian Police Service</option>
                                        <option value="Indian Forest Service">Indian Forest Service</option>
                                        <option value="Bihar Administrative Service">Bihar Administrative Service</option>
                                        <option value="Bihar Police Service">Bihar Police Service</option>
                                        <option value="Bihar Finance Service">Bihar Finance Service</option>
                                        <option value="Bihar Account Service">Bihar Account Service</option>
                                        <option value="Bihar Revenue Service">Bihar Revenue Service</option>
                                        <option value="Bihar Rural Development Service">Bihar Rural Development Service</option>
                                        <option value="Service Of Bihar Engineering">Service Of Bihar Engineering</option>
                                        <option value="Bihar Co-operavtive Account Service">Bihar Co-operavtive Account Service</option>
                                        <option value="Bihar Education Service">Bihar Education Service</option>
                                        <option value="Bihar Health Service">Bihar Health Service</option>
                                        <option value="Bihar Registration Service">Bihar Registration Service</option>
                                        <option value="Bihar Co-operavtive Administrative Service">Bihar Co-operavtive Administrative Service</option>
                                        <option value="Bihar Election Service">Bihar Election Service</option>
                                        <option value="Bihar Agriculture Service">Bihar Agriculture Service</option>
                                        <option value="Bihar Jail Service">Bihar Jail Service</option>
                                        <option value="Bihar Labour Service">Bihar Labour Service</option>
                                        <option value="Bihar Employment Service">Bihar Employment Service</option>
                                        <option value="Bihar ICDS Service">Bihar ICDS Service</option>
                                        <option value="GAD">GAD</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className='card application-form'>
                            <h2 className="ui_section_title">Office Address / कार्यालय का पता</h2>

                            <div className="row  mt-3">
                                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>  Name of the Office/ कार्यालय का नाम</label>
                                <div className="col-sm-8">
                                    <textarea
                                        name='office_address'
                                        value={state.office_address}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        disabled={disabled}
                                        className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                </div>
                            </div>
                            {/* 
              <div className="row">
                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Post Office/डाक घर</label>
                <div className="col-sm-4">
                  <input type="text" className="form-control" id="inputEmail3" />
                </div>
                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>State /राज्य</label>
                <div className="col-sm-4">
                  <select className="form-select" id="autoSizingSelect">
                    <option>Select State/राज्य चुनें</option>
                    <option value="1"></option>
                  </select>
                </div>
              </div> */}

                            {/* <div className="row mb-3 mt-3">
                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"> <i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>District /जिला</label>
                <div className="col-sm-4">
                  <select className="form-select" id="autoSizingSelect">
                    <option>Select District/जिला चुनें</option>
                    <option value="1"></option>
                  </select>
                </div>
                <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"> <i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>PIN / पिन</label>
                <div className="col-sm-4">
                  <input type="text" className="form-control" id="inputEmail3" />
                </div>
              </div> */}

                        </div>

                        {/* Was THREE separate full-width cards — one per upload, each
                            with its own centred red note — which took three screens
                            of scrolling for three file pickers. One section, three
                            columns, notes as quiet hints under each field. */}
                        <div className='card application-form'>
                            <h2 className="ui_section_title">Documents / दस्तावेज़</h2>

                            <div className="ui_uploads">
                                <div className="ui_upload">
                                    <label className="ui_upload_label" htmlFor="upload_photo">
                                        <span className="ui_required">*</span>
                                        Passport size Photo / पासपोर्ट साइज फोटो
                                    </label>
                                    <input
                                        id="upload_photo"
                                        name='photo'
                                        accept="image/*"
                                        onChange={(e) => handleChange(e)}
                                        disabled={disabled}
                                        required={state.photoImg ? false : true}
                                        type="file" className="form-control"
                                    />
                                    <span className="ui_upload_hint">
                                        jpg, jpeg or png · 50 KB to 5 MB · a phone photo is fine
                                    </span>
                                    {state.photoImg ? (
                                        <a className="ui_upload_view" target="_blank" rel="noreferrer"
                                            href={process.env.REACT_APP_FILE_URL + state.photoImg}>
                                            <i className="fa fa-check-circle" aria-hidden="true"></i> View uploaded file
                                        </a>
                                    ) : null}
                                </div>

                                <div className="ui_upload">
                                    <label className="ui_upload_label" htmlFor="upload_signature">
                                        <span className="ui_required">*</span>
                                        Signature / आवेदक का हस्ताक्षर
                                    </label>
                                    <input
                                        id="upload_signature"
                                        name='signature'
                                        accept="image/*"
                                        onChange={(e) => handleChange(e)}
                                        disabled={disabled}
                                        required={state.signatureImg ? false : true}
                                        type="file" className="form-control" />
                                    <span className="ui_upload_hint">
                                        jpg, jpeg or png · 4 KB to 5 MB
                                    </span>
                                    {state.signatureImg ? (
                                        <a className="ui_upload_view" target="_blank" rel="noreferrer"
                                            href={process.env.REACT_APP_FILE_URL + state.signatureImg}>
                                            <i className="fa fa-check-circle" aria-hidden="true"></i> View uploaded file
                                        </a>
                                    ) : null}
                                </div>

                                <div className="ui_upload">
                                    <label className="ui_upload_label" htmlFor="upload_proof">
                                        <span className="ui_required">*</span>
                                        Id Proof / पहचान प्रमाण
                                    </label>
                                    <input type="file" className="form-control" id="upload_proof"
                                        name='proof'
                                        accept="image/*"
                                        disabled={disabled}
                                        onChange={(e) => handleChange(e)}
                                        required={state.proofImg ? false : true}
                                    />
                                    <span className="ui_upload_hint">
                                        jpg, jpeg or png · 50 KB to 5 MB
                                    </span>
                                    {state.proofImg ? (
                                        <a className="ui_upload_view" target="_blank" rel="noreferrer"
                                            href={process.env.REACT_APP_FILE_URL + state.proofImg}>
                                            <i className="fa fa-check-circle" aria-hidden="true"></i> View uploaded file
                                        </a>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className='card application-form'>

                            <div className="ui_declaration">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="gridCheck1" required />
                                    <label className="form-check-label" htmlFor="gridCheck1">
                                        I hereby affirm that all the above given information is true to the best of my knowledge. If any of the details are found to be incorrect, my candidature may be rejected.
                                    </label>
                                </div>
                                {/* Was three bare <li> with no <ol> parent — invalid
                                    HTML, so the browser rendered them unindented with
                                    no numbering — and `listStyleType: 'number'` is not
                                    a valid CSS value ('decimal' is). A real ordered
                                    list numbers itself. */}
                                <div className="ui_declaration_notes">
                                    <p className="ui_declaration_notes_title">नोट</p>
                                    <ol>
                                        <li>आवेदक अनिवार्यतः अपने नियंत्री पदाधिकारी / कार्यालय प्रधान से ही आवेदन अग्रसारित कराकर अपलोड करेंगे।</li>
                                        <li>नियंत्री पदाधिकारी / कार्यालय से आवेदन उपर दिये document अपलोड / step2 पर click कर अपलोड करें।</li>
                                        <li>अपलोड करने के बाद ही आप वास्तविक परीक्षा दें सकते हैं।</li>
                                    </ol>
                                </div>
                            </div>


                        </div>

                    </div>
                    {
                        !disabled && <div className="d-grid gap-2">
                            <button className="ui_btn ui_btn_primary ui_btn_block" type="submit"><i className="fa fa-print" aria-hidden="true"></i> Save &amp; Print</button>
                        </div>
                    }

                    <br />

                    <Link to='/step2' className="d-grid gap-2">
                        <button className="btn btn-primary" type="button"><i className="fa fa-arrow-right"></i>&nbsp;Proceed to next Step</button>
                    </Link>
                </div>
            </form >
            <div className='application-format container-fluid' id='application-format'>
                <div className='complete-application'>
                    <center>
                        <b>
                            <h5>बिहार लोक प्रशासन एवं ग्रामीण विकास संस्थान, बिहार</h5>
                            <h5>आवेदन पत्र </h5>
                            <p>( कृपया आवेदन पत्र भरते समय सूचनाओं को ध्यान से पढ़े )</p>
                        </b>
                    </center>
                    <div className='applicant-detail-box '>
                        <div className='applicant-detail '>
                            <ul style={{ listStyle: 'number' }}>
                                <li>Applicant Name/आवेदक का नाम :</li>
                                <li>Date Of Birth/जन्म तिथि :</li>
                                <li>Service/सेवा :</li>
                                <li>Class/श्रेणी:</li>
                                <li>Office Address/कार्यालय पता :</li>
                                <li>Designation/पद नाम :</li>
                                <li>Department/विभाग :</li>
                                {/* <li>Place/जगह :</li>
                            <li>District/जिला :</li>
                            <li>Employe Id: </li> */}
                            </ul>
                            <ul style={{ listStyle: 'none' }}>
                                <li>{state.name}</li>
                                <li style={{ color: "transparent" }}>.</li>
                                <li>{dateStandard(updateDOB(props.auth.auth?.data?.dob))}</li>
                                {/* <li style={{color:"transparent"}}>.</li> */}
                                <li>{state.service}</li>
                                <li>{state.category}</li>
                                <li>{state.office_address}</li>
                                <li>{state.designation} </li>
                                <li style={{ color: "transparent" }}>.</li>
                                <li>{state.department} </li>
                                {/* <li>{state.service}</li>
                            <li>{state.service} </li>
                            <li>{state.service}</li> */}
                            </ul>
                        </div>
                        <div className='applicant-photo p-5'>
                            <img style={{ width: 100, height: 100 }} src={process.env.REACT_APP_FILE_URL + state.photoImg} alt='applicant_photo' />
                        </div>
                    </div>
                    <div className='appliaction_second_section'>
                        <p>Application Number/आवेदन संख्या: {props.auth.auth?.data?.aadhar} </p>
                        <p>Email Id:/ईमेल: {state.email}</p>
                        <p>Mobile Number/मोबाइल: {state.mobile} </p>
                    </div>

                    <div className='appliaction_memo_section'>
                        <p>Memo/ज्ञापांक &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>Date/दिनांक </span> </p>
                        <p>अग्रसारित नियंत्री पदाधिकारी / कार्यालय प्रधान का हस्ताक्षर ______________________</p>
                        <p>Designation/पद नाम ___________________ </p>
                        <p>Address/पता___________________ </p>
                        <p>Mobile Number/मोबाइल ___________________ </p>
                        <p style={{ textAlign: 'right' }}>Office Seal/कार्यालय मुहर</p>
                    </div>


                    <div className='notice_section'>
                        <p>Note/नोट </p>
                        <div className='note_point'>
                            <ul style={{ listStyle: 'number' }}>
                                <li>Incomplete Application Form Shall be Rejected/अपूर्ण आवेदन पत्र को अस्वीकार कर दिया जाएगा</li>
                                <li>Please Read all the instructions carefully before filling up the form/फॉर्म भरने से पहले कृपया सभी निर्देशों को ध्यान से पढ़ें</li>
                                <li>Application Signature is mandatory on the application form/
                                    आवेदन पत्र पर आवेदन हस्ताक्षर अनिवार्य है</li>
                                <li>Please make sure the details mentioned in the application form should be as same as the details to be filled up in the examination hall/कृपया सुनिश्चित करें कि आवेदन पत्र में उल्लिखित विवरण परीक्षा हॉल में भरे जाने वाले विवरण के समान होना चाहिए</li>
                                <li>Candidate application shold be forwarded by his/her controlling officer/head  of department/head  of the office only and then have to upload the same. forwarding from any other official on the application form will not be considered for valid candidate. pplication without "memo" and "date" will be rejected/उम्मीदवार के आवेदन को उसके नियंत्रण अधिकारी/विभागाध्यक्ष/कार्यालय प्रमुख द्वारा ही अग्रेषित किया जाना चाहिए और फिर उसे अपलोड करना होगा। आवेदन पत्र पर किसी अन्य अधिकारी से अग्रेषित करने पर वैध उम्मीदवार के लिए विचार नहीं किया जाएगा। "ज्ञापन" और "तारीख" के बिना आवेदन खारिज कर दिया जाएगा</li>
                            </ul>


                        </div>
                        <div className='applicant-photo p-5'>
                            <img style={{ width: 120, height: 100 }} src={process.env.REACT_APP_FILE_URL + state.signatureImg} alt='applicant_photo' />
                            <p>आवेदक के हस्ताक्षर </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.Auth
    }
}

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(ApplicationForm);